<div class="container-fluid modal-window">
  <div class="row">
    <div class="add-students-to-group-panel">
      <div class="top-div">
        <h1 class="main-title">Export Students to CSV</h1>
        <div *ngIf="!isOverLimit">
          <p>
            This export will include {{ data.studentCount }} student{{
              data.studentCount != 1 ? "s" : ""
            }}.
          </p>
          <p>
            Caution: You are about to download sensitive student data.<br />
            Always follow your district's policies about using, storing, and
            sharing this data.
          </p>
        </div>
        <div *ngIf="isOverLimit">
          <p>
            Sorry! There is too much data included in this export.<br />
            Please filter or select a view in order to export data<br />
            (the max number of students is 25,000).
          </p>
        </div>
      </div>

      <div class="error-panel">
        <p class="help-text error-text" *ngIf="error">
          Action failed: contact
          <a
            href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395"
            target="_blank"
            title="Support"
            class="support-link"
            >support</a
          >
          for assistance.
        </p>
      </div>

      <div class="button-panel">
        <button
          mat-raised-button
          class="cancel-button"
          (click)="closeModal()"
          alt="Close modal"
        >
          CANCEL
        </button>
        <button
          mat-raised-button
          class="right"
          [ngClass]="!isOverLimit ? 'export-button' : ''"
          (click)="exportToCSV()"
          [disabled]="isOverLimit"
          alt="Export Student to CSV"
        >
          EXPORT
        </button>
      </div>
    </div>
  </div>
</div>
